import { usePage } from "@inertiajs/vue3";
import type { PageProps } from "@internal-types/index";
import { defineStore } from "pinia";
import { reactive } from "vue";

export const useI18nStore = defineStore(
    "i18nStore",
    () => {
        const page = usePage<PageProps<Domain.Shared.Data.MainSharedData>>();
        return reactive({
            translations: { ...page.props.translations, ...page.props.i18n.translations },
            locale: page.props.i18n.locale as Domain.UI.Enums.Locale,
            country: page.props.i18n.country,
        });
    },
    { persist: false },
);
